import { maintenanceNotes } from "@/mocks/home";

export default function NoteSection() {
  return (
    <section id="notes" className="py-14 md:py-20 bg-primary-50 border-y border-primary-100">
      <div className="mx-auto max-w-content px-4 md:px-6">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 px-3 py-1 text-xs font-label rounded-full bg-primary-100 text-primary-800 border border-primary-200">
            <i className="ri-tools-line" />
            入口维护说明
          </span>
          <h2 className="mt-4 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            关于地址维护与日常使用的几点说明
          </h2>
          <p className="mt-3 text-sm md:text-base leading-relaxed text-foreground-700">
            以下是围绕入口维护、栏目调整与安全访问的通用说明，帮助你更从容地应对地址变化与访问异常。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {maintenanceNotes.map((n) => (
            <article
              key={n.title}
              className="flex flex-col p-5 rounded-lg bg-background-50 border border-primary-100"
            >
              <span className="inline-flex self-start px-2.5 py-1 text-xs font-label rounded-full bg-primary-500 text-background-50">
                {n.tag}
              </span>
              <span className="mt-4 w-10 h-10 flex items-center justify-center rounded-md bg-accent-100 text-accent-700">
                <i className={`${n.icon} text-xl`} />
              </span>
              <h3 className="mt-4 font-heading text-base font-semibold text-foreground-950">{n.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-700">{n.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}